import { inject, Injectable } from "@angular/core";
import { Book, IBookSortFilterSet } from "../_models";
import { AuthorChipsComponent } from "../components/chips/author-chips/author-chips.component";
import { ASTWithName } from "@angular/compiler";
import { BookService } from "./book.service";

@Injectable()
export class FilterSortService {

  bookService = inject(BookService);

  sortFilterList(inList: Book[], sortFilterSet: IBookSortFilterSet): Book[] {

    let outList = inList;
    const filterSet = sortFilterSet as IBookSortFilterSet;

    outList = this.doFiltering(outList, filterSet);
    outList = this.doSorting(outList, filterSet);
    return outList;
  }

  doFiltering = (inList: Book[], filterSet: IBookSortFilterSet): Book[] => {
    let outList = inList;

    // Filter on Book Type
    if (filterSet['typeSelect'] && filterSet['typeSelect'] != 'Both') {
      outList = outList.filter((book: Book) => {
        return (book['type'].toLocaleLowerCase() == filterSet['typeSelect']!.toLocaleLowerCase());
      });
    }

    // Filter titles
    if (filterSet['titleSearchTerm'] && filterSet['titleSearchTerm'] !== '') {
      if (filterSet['startsWithFlag'] === true) {
        // If starts with
        outList = outList.filter((book: Book) =>
          book['title'].toLocaleLowerCase().startsWith(filterSet['titleSearchTerm']!.toLocaleLowerCase()));
      } else {
        // IF contains
        outList = outList.filter((book: Book) =>
          book['title'].toLocaleLowerCase().indexOf(filterSet['titleSearchTerm']!.toLocaleLowerCase()) !== -1);
      }
    }

    // Filter Type
    if (filterSet['typeSelect'] && filterSet['typeSelect'] != 'Both') {
      outList = outList.filter((book: Book) => {
        return (book['type'].toLocaleLowerCase() == filterSet['typeSelect']!.toLocaleLowerCase());
      });
    }

    // Filter titles
    if (filterSet['titleSearchTerm'] && filterSet['titleSearchTerm'] !== '') {
      if (filterSet['startsWithFlag'] === true) {
        // If starts with
        outList = outList.filter((book: Book) =>
          book['title'].toLocaleLowerCase().startsWith(filterSet['titleSearchTerm']!.toLocaleLowerCase()));
      } else {
        // IF contains
        outList = outList.filter((book: Book) =>
          book['title'].toLocaleLowerCase().indexOf(filterSet['titleSearchTerm']!.toLocaleLowerCase()) !== -1);
      }
    }

    // Filter Series
    if (filterSet['seriesFilter'] && filterSet['seriesFilter'] != '-- Select a Series --') {
      outList = outList.filter((book: Book) => {
        if (book.series && book.series?.length > 0) { // part of a series
          if (book.series.findIndex((s) => { // is series selection in that list
            return s.name == filterSet['seriesFilter'];
          }) > -1) {
            return true // if so - keep
          } else { // part of a series, but not the selected one
            return false
          }
          // selected a series so default order to reading order

        } else {     // book is not part of a series
          if (filterSet['seriesFilter'] == '-- Not Part of a Series --') {
            return true;
          } else {
            return false
          }
        }
      });
    }

    // Filter Authors
    if (filterSet['authorFilter'] && filterSet['authorFilter'] != '-- Select an Author --') {
      outList = outList.filter((book: Book) => {
        return (book.authors?.includes(filterSet['authorFilter']!));
      });
    }

    // Filter Narrators
    if (filterSet['narratorFilter'] && filterSet['narratorFilter'] != '-- Select a Narrator --') {
      outList = outList.filter((book: Book) => {
        return (book.narrators?.includes(filterSet['narratorFilter']!));
      });
    }

    // If a user logged in can filter on added, recommendation, interested
    if (sessionStorage.getItem('user_token')) {
      const me = JSON.parse(sessionStorage.getItem('user_token')!).username;
      // added by me
      if (filterSet['addedByMe']) {
        outList = outList.filter((book: Book) => {
          return (this.bookService.getAddedByMe(book));
        });
      }
      // I have NOT Read
      if (filterSet['notReadByMe']) {
        outList = outList.filter((book: Book) => {
          return ( ! this.bookService.getIHaveRead(book));
        });
      }

      // I'm interested in
      if (filterSet['imInterestedIn']) {
        outList = outList.filter((book: Book) => {
          return (this.bookService.getImInterested(book));
        });
      }

      // recommended for me
      if (filterSet['recommendedForMe']) {
        outList = outList.filter((book: Book) => {
          return (book.recommendations && book.recommendations.map(r => r.to).includes(me!));
        });
      }

      // recommended by me
      if (filterSet['recommendedByMe']) {
        outList = outList.filter((book: Book) => {
          return (book.recommendations && book.recommendations.map(r => r.from).includes(me!));
        });
      }

      // I Have Read
      if (filterSet['haveRead']) {
        outList = outList.filter((book: Book) => {
          return (this.bookService.getIHaveRead(book));
        });
      }
      // Not added by me
      if (filterSet['notAddedByMe']) {
        outList = outList.filter((book: Book) => {
          return ( ! this.bookService.getAddedByMe(book));
        });
      }

    }
    return outList;
  }

  // ----- Finally Sort the filtered List -----
  doSorting(inList: Book[], filterSet: IBookSortFilterSet): Book[] {
    let outList = inList;
    const desc = filterSet['sortDirection'] == 'desc' ? true : false;

    switch (filterSet['sortBy']) {

      case 'recentlyAdded':
        outList.sort((a, b) => {
          const aVal = a.purchaseDate ? a.purchaseDate : ('0000-00-00');
          const bVal = b.purchaseDate ? b.purchaseDate : ('0000-00-00');
          if (aVal > bVal) { return -1 }
          if (aVal < bVal) { return 1 }
          return 0;
        });
        break;
      case 'seriesReadingOrder':
        // Should only happen if a seriesFilter is set, the FilteredList should all be in the series
        outList.sort((a, b) => {
          const aName = (a.series![0] ? a.series![0].name.toLocaleUpperCase() : 'zzzz');
          const bName = (b.series![0] ? b.series![0].name.toLocaleUpperCase() : 'zzzz');

          if (aName < bName) { return -1 }
          if (aName > bName) { return 1 }
          const aOrder = (a.series![0] ? a.series![0].readingOrder : 0);
          const bOrder = (b.series![0] ? b.series![0].readingOrder : 0);
          if (aOrder < bOrder) { return -1 }
          if (aOrder > bOrder) { return 1 }
          // no series - sort by title
          const aVal = a.title.toLocaleUpperCase();
          const bVal = b.title.toLocaleUpperCase();
          if (aVal < bVal) { return -1 }
          if (aVal > bVal) { return 1 }
          return 0;

        });
        break;

      case 'series':
        outList.sort((a, b) => {
          const aName = (a.series![0] ? a.series![0].name.toLocaleUpperCase() : 'zzzz');
          const bName = (b.series![0] ? b.series![0].name.toLocaleUpperCase() : 'zzzz');

          if (aName < bName) { return -1 }
          if (aName > bName) { return 1 }
          const aOrder = (a.series![0] ? a.series![0].readingOrder : 0);
          const bOrder = (b.series![0] ? b.series![0].readingOrder : 0);
          if (aOrder < bOrder) { return -1 }
          if (aOrder > bOrder) { return 1 }
          // no series - sort by title
          const aVal = a.title.toLocaleUpperCase();
          const bVal = b.title.toLocaleUpperCase();
          if (aVal < bVal) { return -1 }
          if (aVal > bVal) { return 1 }

          return 0;

        });
        break;

      case 'titleWithout':
        outList.sort((a, b) => {
          const aVal = this.stripArticle(a.title);
          const bVal = this.stripArticle(b.title);
          if (aVal < bVal) { return -1 }
          if (aVal > bVal) { return 1 }
          return 0;
        });
        break;

      case 'author':
        outList.sort((a, b) => {
          if (a == null || b == null) {
            return 1
          }
          if (a.authors == null || b.authors == null) {
            return 1
          }
          if (a.authors.length == 0 || b.authors.length == 0) {
            return 1

          }

          const aVal = a.authors[0].toLocaleUpperCase();
          const bVal = b.authors[0].toLocaleUpperCase();
          if (aVal < bVal) { return -1 }
          if (aVal > bVal) { return 1 }
          // same author - sort by title
          const aTitle = a.title.toLocaleUpperCase();
          const bTitle = b.title.toLocaleUpperCase();
          if (aTitle < bTitle) { return -1 }
          if (aTitle > bTitle) { return 1 }
          return 0;
        });

        break
      default:   // By Title
        outList.sort((a, b) => {
          if (a == null || b == null) {
            return 1
          }
          const aVal = a.title.toLocaleUpperCase();
          const bVal = b.title.toLocaleUpperCase();
          if (aVal < bVal) { return -1 }
          if (aVal > bVal) { return 1 }
          return 0;
        });

    }
    if (desc) {
      outList.reverse();
    }
    return outList;
  }


  getReadingOrder(book: Book, grp: string): number {
    let indx = -1;

    for (let i = 0; i <= book.series!.length; i++) {
      if (book.series![i].name == grp) {
        indx = i;
        break;
      }
    }
    if (indx > -1) {
      return book.series![indx].readingOrder
    }
    return 0
  }

  stripArticle(str: string): string {
    let retStr = str;
    if (retStr.toUpperCase().substring(0, 3) == 'THE ') {
      retStr = retStr.substring(4) + ', ' + 'THE'
    } else
      if (retStr.toUpperCase().substring(0, 2) == 'A ') {
        retStr = retStr.substring(2) + ', ' + 'A'
      }
    return retStr.toUpperCase()
  }
}